// @flow
import { createContext } from 'react';

export const EstimateCommittedCapacityMetadataContext = createContext({});
